module.exports = __webpack_public_path__ + "img/worksbot_img19121105.4e33804a.jpg";